import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Component, Inject, OnInit} from '@angular/core';
import {Group} from '../../../shared/models/group.model';

@Component({
  selector: 'dialog-groups-select',
  templateUrl: 'dialog-groups-select.html',
  styleUrls: ['dialog-groups-select.scss']
})

export class DialogGroupsSelect implements OnInit {

  selectedGroup: Group;

  constructor(public dialogRef: MatDialogRef<DialogGroupsSelect>,
              @Inject(MAT_DIALOG_DATA) public data: { groups: Group[] }) {

    this.selectedGroup = data.groups[0];
  }

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/remote/game/dialog-groups-select/dialog-groups-select.ts